export default "__VITE_ASSET__Cur42FBd__"